export function truncate(len: number) {
  return function(str: string) {
    return str.length <= len ? str : str.slice(0, len - 3).trim() + '...';
  };
}
